import { atom } from 'recoil';

import { IProduct } from 'Interfaces/Product';

export const productsState = atom<Array<IProduct>>({
	key: 'productsState',
	default: []
});
